import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as zephyr from './zephyr';
import * as tios from './tios';

export default class SettingsInitializeNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Socket Connect';
        this.id = 'node_socket_connect';
        this.icon = 'FaNetworkWired';
        this.linkedFeature = 'socket';

        this.inputs = [
            {
                name: 'Connect',
                portId: 'connect',
                params: [
                ],
            },
        ];

        this.settings = this.settings.concat([
            {
                id: 'SOCKET',
                name: 'Socket',
                settingType: SettingType.OPTION,
                refId: 'socket_connection',
                default: '',
            },
        ]);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
